const CARDS = [
  {
    title: '韩漫之家 — 最全韩漫综合平台',
    desc: '收录海量韩漫资源，涵盖恋爱、奇幻、热血等全题材，更新速度快，是韩漫爱好者首选入口。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20digital%20library%20filled%20with%20colorful%20comic%20books%20on%20shelves%2C%20soft%20cream%20and%20beige%20background%2C%20organized%20and%20cozy%20atmosphere%2C%20flat%20illustration%20style%20with%20gentle%20warm%20lighting&width=600&height=400&seq=cards-01-2026&orientation=landscape',
    tag: '综合平台',
    stat: '2000+ 部',
  },
  {
    title: '韩漫屋 — 清爽免费韩漫阅读',
    desc: '界面简洁无广告干扰，免费韩漫在线观看体验极佳，每日更新稳定，支持收藏与追更提醒。',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20and%20minimalist%20illustration%20of%20a%20tablet%20on%20a%20wooden%20desk%20showing%20a%20comic%20reader%20interface%2C%20warm%20beige%20background%20with%20a%20small%20plant%2C%20peaceful%20reading%20atmosphere%2C%20modern%20flat%20illustration&width=600&height=400&seq=cards-02-2026&orientation=landscape',
    tag: '免费阅读',
    stat: '每日更新',
  },
  {
    title: '韩漫网 — 经典韩漫收藏馆',
    desc: '老牌韩漫漫画网站，经典完结韩漫一网打尽。适合回顾经典作品与发现冷门宝藏韩漫。',
    image: 'https://readdy.ai/api/search-image?query=A%20vintage%20style%20illustration%20of%20a%20collection%20of%20classic%20books%20with%20warm%20sepia%20and%20cream%20tones%2C%20nostalgic%20library%20atmosphere%20with%20soft%20lighting%2C%20artistic%20flat%20illustration%2C%20timeless%20elegance&width=600&height=400&seq=cards-03-2026&orientation=landscape',
    tag: '经典收藏',
    stat: '1500+ 部',
  },
  {
    title: '韩漫吧 — 活跃漫迷社区',
    desc: '以社区讨论为特色的韩漫网址入口，漫迷在这里分享推荐、讨论剧情，发现更多同好。',
    image: 'https://readdy.ai/api/search-image?query=A%20lively%20community%20illustration%20with%20speech%20bubbles%20and%20colorful%20comic%20elements%20floating%20around%2C%20warm%20cream%20background%2C%20friendly%20and%20energetic%20flat%20illustration%20style%2C%20social%20interaction%20concept&width=600&height=400&seq=cards-04-2026&orientation=landscape',
    tag: '社区讨论',
    stat: '50万+ 用户',
  },
  {
    title: '韩漫在线 — 移动端首选',
    desc: '专为手机阅读优化的韩漫在线观看平台，支持离线缓存与夜间模式，随时随地畅享韩漫。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20illustration%20of%20a%20hand%20holding%20a%20smartphone%20with%20a%20comic%20page%20displayed%2C%20warm%20beige%20background%2C%20minimalist%20flat%20design%2C%20mobile%20reading%20concept%20with%20soft%20evening%20tones&width=600&height=400&seq=cards-05-2026&orientation=landscape',
    tag: '移动阅读',
    stat: 'iOS + 安卓',
  },
  {
    title: '韩漫导航 — 一站式聚合入口',
    desc: '韩漫网址大全聚合导航，一键直达各大韩漫网站。持续收录新平台，做你追漫路上的贴心向导。',
    image: 'https://readdy.ai/api/search-image?query=A%20compass%20and%20map%20themed%20illustration%20with%20colorful%20comic%20elements%20guiding%20paths%2C%20warm%20cream%20and%20beige%20background%2C%20navigation%20and%20discovery%20concept%2C%20friendly%20flat%20illustration%20style%2C%20exploration%20atmosphere&width=600&height=400&seq=cards-06-2026&orientation=landscape',
    tag: '聚合导航',
    stat: '200+ 平台',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选优质韩漫网站平台，发现属于你的韩漫入口
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((card, i) => (
            <article
              key={i}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-background-50/90 text-foreground-700 px-2 py-1 rounded font-medium backdrop-blur-sm">
                    {card.stat}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-[10px] bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
                  {card.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mt-2 mb-1">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}